import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TypographyBase from '@material-ui/core/Typography';

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing.unit * 3,
        maxWidth: 1000,
        marginLeft: 'auto',
        marginRight: 'auto'
    }),
    center: {
        textAlign: 'center'
    },
    monospace: {
        fontFamily: 'monospace'
    }
});

class Typography extends Component {
    render() {
        const {
            id,
            component,
            children,
            fitText,
            classes,
            className
        } = this.props;

        let style = this.props.style || {};
        if (id && fitText) {
            style.height = '80vh';
            setTimeout(() => {
                let el = document.getElementById(id);
                el.style.fontSize = '100px';
                let currentFontSize = 100;

                while (
                    el.scrollHeight > el.offsetHeight ||
                    el.scrollWidth > el.offsetWidth
                ) {
                    currentFontSize -= currentFontSize / 10;
                    el.style.fontSize = currentFontSize + 'px';
                }
            }, 500);
        }

        return (
            <TypographyBase
                id={id}
                component={component}
                style={style}
                className={classes[className]}
            >
                {children}
            </TypographyBase>
        );
    }
}

export default withStyles(styles)(Typography);



// WEBPACK FOOTER //
// ./src/components/layout/Typography.js